import * as React from "react";
type Props = {
  className?: string,
};
function SvgTag({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-tag"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.90144 1.33486C7.09008 1.32206 7.27528 1.38996 7.41095 1.52165L13.7976 7.72165C13.9257 7.846 13.9986 8.01653 13.9999 8.19505C14.0012 8.37357 13.9309 8.54517 13.8047 8.6714L8.47132 14.0047C8.34429 14.1318 8.17137 14.2022 7.99174 14.1999C7.8121 14.1977 7.64096 14.1231 7.51709 13.993L1.55709 7.73302C1.44114 7.61124 1.3755 7.45014 1.37331 7.28201L1.33331 4.20867C1.33097 4.02887 1.40136 3.85574 1.52851 3.72859L3.52851 1.72859C3.6425 1.6146 3.79394 1.54578 3.95477 1.53486L6.90144 1.33486ZM4.29452 2.8482L2.67019 4.47254L2.70312 7.00309L8.01163 12.5788L12.3834 8.20704L6.69536 2.68525L4.29452 2.8482Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64659 6.23333C4.77896 6.38685 4.95382 6.49774 5.14911 6.55203C5.34441 6.60633 5.55141 6.60159 5.74402 6.53843C5.93664 6.47527 6.10624 6.3565 6.23146 6.19709C6.35668 6.03769 6.43191 5.84479 6.44767 5.6427C6.46343 5.44061 6.41901 5.23837 6.32001 5.06149C6.22102 4.8846 6.07188 4.74097 5.89139 4.64872C5.71089 4.55646 5.50713 4.51969 5.30578 4.54305C5.10442 4.56642 4.91449 4.64886 4.75992 4.78C4.65658 4.86767 4.57162 4.97493 4.50994 5.0956C4.44826 5.21627 4.41108 5.34795 4.40055 5.48306C4.39001 5.61817 4.40633 5.75402 4.44856 5.88279C4.49079 6.01157 4.55809 6.1307 4.64659 6.23333Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgTag;
